import {
    PATH_ROOT,
    PATH_ORDERS,
    PATH_STOCK,
    PATH_STOCK_PALLET,
    PATH_ORDER_NEW,
    PATH_ORDERS_ARCHIVE,
} from './routerPaths';
import { NavigationElement } from '../layout/vms/NavigationElement';

export const navigationElements: NavigationElement[] = [
    {
        name: 'dashboard.title',
        link: PATH_ROOT,
        childs: [],
    },
    {
        name: 'orders.title',
        link: PATH_ORDERS,
        childs: [
            {
                name: 'orders.create',
                link: PATH_ORDER_NEW,
                childs: [],
            }
        ],
    },
    {
        name: 'stock.title',
        link: PATH_STOCK,
        childs: [],
    },
    {
        name: 'palletStock.title',
        link: PATH_STOCK_PALLET,
        childs: [],
    },
];
